{
  "version": "1.0",
  "builder": "data",
  "stepperOrientation": "horizontal",
  "linear": false,
  "steps": [
    {
      "id": "source",
      "label": "Source",
      "sections": [
        {
          "id": "source",
          "fields": [{ "field": "upload" }]
        }
      ]
    },
    {
      "id": "pipeline",
      "label": "Pipeline",
      "sections": [
        {
          "id": "pipeline",
          "fields": [{ "field": "computations" }]
        }
      ]
    },
    {
      "id": "preview",
      "label": "Preview",
      "visible": false,
      "sections": [
        {
          "id": "preview",
          "fields": []
        }
      ]
    },
    {
      "id": "deploy",
      "label": "Deploy",
      "visible": false,
      "sections": [
        {
          "id": "deploy",
          "fields": []
        }
      ]
    }
  ],

  "pipelineDashboard": {
    "brand": {
      "name": "Kaveri Lite",
      "logoMark": "multi-color-k",
      "title": "Data Builder",
      "breadcrumbs": ["Home", "Data Builder", "Customer Profitability Model"]
    },
    "actions": [
      {
        "id": "save-preview-outline",
        "label": "Save Preview",
        "icon": "open_in_new",
        "variant": "outline"
      },
      {
        "id": "save-preview-primary",
        "label": "Save Preview",
        "icon": "hourglass_empty",
        "variant": "primary"
      }
    ],
    "workflow": {
      "activeStep": "pipeline",
      "steps": [
        {
          "id": "source",
          "order": 1,
          "label": "Source",
          "subtitle": "Upload Files",
          "status": "complete"
        },
        {
          "id": "pipeline",
          "order": 2,
          "label": "Pipeline",
          "subtitle": "Build Pipeline",
          "status": "active"
        },
        {
          "id": "preview",
          "order": 3,
          "label": "Preview",
          "subtitle": "Preview Data",
          "status": "pending"
        },
        {
          "id": "deploy",
          "order": 4,
          "label": "Deploy",
          "subtitle": "Schedule & Deploy",
          "status": "pending"
        }
      ]
    },
    "sourcesPanel": {
      "title": "Sources",
      "count": 0,
      "addActionLabel": "Add Source",
      "files": [],
      "stepLibrary": [
        {
          "id": "translation",
          "label": "Translation",
          "description": "Map values, create dictionary",
          "accent": "#2563eb",
          "icon": "translate"
        },
        {
          "id": "transformation",
          "label": "Transformation",
          "description": "Create rules, formulas, modify",
          "accent": "#7c3aed",
          "icon": "schema"
        },
        {
          "id": "relationship",
          "label": "Relationship",
          "description": "Join datasets, define keys",
          "accent": "#16a34a",
          "icon": "hub"
        },
        {
          "id": "validation",
          "label": "Rules",
          "description": "Data quality, business rules",
          "accent": "#f43f5e",
          "icon": "verified_user"
        }
      ]
    },
    "designer": {
      "title": "Pipeline Designer",
      "subtitle": "Build your data pipeline",
      "autoArrange": true,
      "zoom": 100,
      "selectedNodeId": "",
      "nodes": [],
      "edges": []
    },
    "detailsPanel": {
      "tabs": [
        { "id": "node-details", "label": "Node Details", "active": true },
        { "id": "applied-steps", "label": "Applied Steps (6)", "active": false }
      ],
      "node": {
        "id": "relationship-1",
        "type": "Relationship",
        "description": "Join datasets using business keys",
        "nodeName": "Sales + Customer",
        "joinType": "Left Join",
        "joinTypes": ["Left Join", "Right Join", "Inner Join", "Outer Join"],
        "datasets": {
          "left": "Sales.xlsx (after transformations)",
          "right": "Customer.xlsx (after transformations)"
        },
        "joinKeys": [
          {
            "leftColumn": "Customer_ID",
            "operator": "=",
            "rightColumn": "Customer_ID"
          }
        ]
      }
    },
    "bottomPanel": {
      "activeTab": "data-preview",
      "tabs": [
        { "id": "data-preview", "label": "Data Preview" }
      ],
      "rowCountLabel": "Rows: 0",
      "exportActionLabel": "Export",
      "previewTitle": "Translation preview",
      "columns": [],
      "rows": []
    }
  },

  "options": {
    "filterOperators": ["=", "!=", ">", "<", ">=", "<=", "IN", "NOT IN", "LIKE", "IS NULL", "IS NOT NULL", "BETWEEN"],
    "logicalOperators": ["AND", "OR"],
    "entityGroup": "NontimeSeriesEntities",
    "acceptedFileTypes": ".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    "hiddenColumns": ["uuid", "source_row_hash", "sourced_row_hash", "_spriced_row_hash", "created_at", "updated_date", "created_date", "updated_by", "created_by"],
    "formulaTemplates": [
      { "id": "sum", "label": "Sum", "kind": "aggregation", "category": "Sum", "description": "Sum of a column within each group", "defaultName": "Total", "expressionTemplate": "sum([Column])" },
      { "id": "avg", "label": "Average", "kind": "aggregation", "category": "Average", "description": "Average of a column within each group", "defaultName": "Average", "expressionTemplate": "avg([Column])" },
      { "id": "count", "label": "Count", "kind": "aggregation", "category": "Count", "description": "Row count within each group", "defaultName": "Count", "expressionTemplate": "count([Column])" },
      { "id": "distinct-count", "label": "Distinct Count", "kind": "aggregation", "category": "Count", "description": "Distinct row count within each group", "defaultName": "Distinct count", "expressionTemplate": "distinctCount([Column])" },
      { "id": "pct-of-total", "label": "Percentage", "kind": "aggregation", "category": "Percentage", "description": "Group share as percent", "defaultName": "Share %", "expressionTemplate": "(sum([Column]) / sum([TotalColumn])) * 100" },
      { "id": "ratio", "label": "Ratio", "kind": "aggregation", "category": "Ratio", "description": "Ratio of two sums", "defaultName": "Ratio", "expressionTemplate": "sum([Numerator]) / sum([Denominator])" },
      { "id": "derived-margin", "label": "Margin", "kind": "column", "category": "Derived", "description": "Row-level margin %", "defaultName": "Margin", "expressionTemplate": "([Profit] / [Revenue]) * 100" },
      { "id": "derived-diff", "label": "Diff", "kind": "column", "category": "Derived", "description": "Row-level difference", "defaultName": "Diff", "expressionTemplate": "[ColumnA] - [ColumnB]" },
      { "id": "derived-pct", "label": "Percent of", "kind": "column", "category": "Percentage", "description": "Row-level percentage of two columns", "defaultName": "Percent", "expressionTemplate": "([Part] / [Whole]) * 100" },
      { "id": "derived-concat", "label": "Concat", "kind": "column", "category": "Derived", "description": "Concatenate two text columns", "defaultName": "Concat", "expressionTemplate": "concat([First], \" - \", [Second])" }
    ]
  },

  "defaults": {
    "previewRows": 10,
    "maxRows": 125000
  },

  "// saveEstimate": "Drives the 'this will take about N minutes' notice on Save Dataset. `rowsPerMinute` is the observed backend throughput — the ONE number to retune when the pipeline gets faster or slower (measure: rows saved ÷ minutes taken). The range shown is rowsPerMinute scaled by lowFactor/highFactor, so 100000 rows at 14000/min ⇒ 7.1 min low, 10.0 min high ('7-10 min'). `minMinutes` floors the estimate so a tiny file never claims '0 min'; `showFromRows` hides the notice entirely for files small enough that nobody cares.",
  "saveEstimate": {
    "rowsPerMinute": 14000,
    "lowFactor": 1,
    "highFactor": 1.4,
    "minMinutes": 1,
    "showFromRows": 5000
  },

  "// apiEndpoints": "schemaListUrl/workflowListUrl feed the top-left Schema/Workflow dropdowns on the Data Builder. Absolute URL or a path relative to baseUrl; leave empty to use the default fallback paths in self-service-api.utils.ts (getSelfServiceSchemaListApiUrl/getSelfServiceWorkflowListApiUrl) until the real backend routes are confirmed.",
  "apiEndpoints": {
    "baseUrl": "",
    "uploadUrl": "",
    "chatUrl": "/ppt-dashboard/generate",
    "schemaListUrl": "/api/projects/schema",
    "workflowListUrl": "/wfm"
  }
}
